import { render, staticRenderFns } from "./WaveletPurchaseForm.vue?vue&type=template&id=c6b48c2c"
import script from "./WaveletPurchaseForm.vue?vue&type=script&lang=js"
export * from "./WaveletPurchaseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports